import React, { useState } from 'react';
import contactusimg from '../Images/contactusimg.png';
import wplogo from '../Images/wplogo.png';
import { AppConstant } from '../AppConstant';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { motion } from "framer-motion";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState(""); // success/error message

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload

    try {
      const response = await fetch("https://formspree.io/f/xkgvwaen", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("✅ Message sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" }); // reset form
      } else {
        setStatus("❌ Failed to send message. Try again later.");
      }
    } catch (error) {
      console.error(error);
      setStatus("⚠️ Something went wrong!");
    }
  };

  return (
    <>
      <Header />
      <div style={styles.sectionStyle}>

        <motion.h2
          style={styles.heading}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Get in <span style={styles.orangeText}>Touch</span>
        </motion.h2>


        <motion.h2 style={styles.titleStyle}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
        >
          If You Have Any Queries, Feel Free to Contact Us.
        </motion.h2>

        {/* Contact image */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={contactusimg}
            alt="contactus"
            style={{ width: "600px", height: "400px", objectFit: "contain" }}
          />
        </div>

        {/* Info cards */}
        <div style={styles.infoGrid}>
          <div style={styles.infoBox}>
            <img src={wplogo} alt="wplogo" style={styles.iconBox} />
            <div>
              <h4 style={{ textTransform: "capitalize", }}>Whatsapp to ask any question</h4>
              <a
                href="https://wa.me/919860099980?text=Hi%20I%20want%20to%20inquiry%20for%20structure%20engineering"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#25D366", textDecoration: "none", fontWeight: "bold" }}
              >
                +91 9860099980
              </a>{" / "}
              <a
                href="https://wa.me/13144793530?text=Hi%20I%20want%20to%20inquiry%20for%20structure%20engineering"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#25D366", textDecoration: "none", fontWeight: "bold" }}
              >
                +1 (314)4793530
              </a>
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.iconBox}>📧</div>
            <div>
              <h4 style={{ textTransform: "capitalize", }}>Email to get free quote</h4>
              <a
                href="mailto:info@structguard.com?subject=Free%20Quote%20Request&body=Hi%20Team%2C%0AI%20would%20like%20to%20request%20a%20free%20quote%20for%20my%20project."
                style={{ color: "#2563eb", textDecoration: "none", fontWeight: "bold" }}
              >
                info@structguard.com
              </a>
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.iconBox}>📍</div>
            <div>
              <h4 style={{ textTransform: "capitalize", }}>Visit our office</h4>
              <a
                href="https://www.google.com/maps?q=418+Platinum+9,+Pashan-Sus+Road,+Behind+Audi+Showroom,+Baner,+Pune+MH-411045"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ef4444", textDecoration: "none", fontWeight: "bold" }}
              >
                418 Platinum 9, Pashan-Sus Road, Behind Audi Showroom, Baner, Pune MH-411045
              </a>
            </div>
          </div>
        </div>

        {/* Form + Map */}
        <div style={styles.formMapContainer}>
          <form style={styles.formStyle} onSubmit={handleSubmit}>
            <div style={styles.rowStyle}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                style={styles.inputStyle}
                onChange={handleChange}
                value={formData.name}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                style={styles.inputStyle}
                onChange={handleChange}
                value={formData.email}
                required
              />
            </div>

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              style={styles.inputStyle}
              onChange={handleChange}
              value={formData.subject}
              required
            />

            <textarea
              name="message"
              placeholder="Message"
              rows="5"
              style={styles.inputStyle}
              onChange={handleChange}
              value={formData.message}
              required
            />

            <button type="submit" style={styles.buttonStyle}>
              Send Message
            </button>

            {/* Success/error message */}
            {status && <p>{status}</p>}
          </form>

          <iframe
            title="Structguard Map"
            style={styles.mapStyle}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1891.2925120960206!2d73.76755934442748!3d18.547645600000017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bee9fafbc545%3A0x7ba7e43566bcaa7d!2sPlatinum%209!5e0!3m2!1sen!2sin!4v1752729399539!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      <Footer />
    </>
  );
};


const styles = {
  sectionStyle: {
    padding: '2rem',
    // maxWidth: '1200px',
    // margin: 'auto',
    fontFamily: 'Segoe UI, sans-serif',
    // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',/
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    // backgroundAttachment: "fixed",
    background: '#ffffff'
    // minHeight: '100vh',

  },

  headingStyle: {
    textAlign: 'center',
    color: 'orange',
    fontWeight: 'bold',
    fontSize: '1rem',
  },

  titleStyle: {
    // textAlign: 'center',
    // fontSize: '2rem',
    // marginBottom: '2rem',
    // fontWeight: '700',
    // color: 'grey',

    maxWidth: 940,
    margin: "12px auto 32px",
    fontSize: '2rem',
    textAlign: 'center',
    marginBottom: '40px',
    fontWeight: "bold",
    fontStyle: 'italic',
    marginLeft: 'auto',
    marginRight: 'auto',
    // color: 'lightgrey',
    color: '#0A1733',
    // textTransform: "capitalize",

    // textDecoration: "underline 2px rgb(255, 101, 0)",

    textUnderlineOffset: "10px",
    letterSpacing: "2px",
  },

  infoGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap', // allows wrapping on small screens
    gap: '1.5rem',
    padding: '2rem',

  },
  infoBox: {
    flex: '1 1 calc(33.33% - 1rem)', // 3 in a row
    // display: 'flex',
    alignItems: 'center',
    // gap: '1rem',
    // padding: '1rem',
    // border: '1px solid #ddd',
    // borderRadius: '8px',
    // backgroundColor: '#fff',
    // boxShadow: '0 2px 6px rgba(0,0,0,0.1)',

    background: 'rgba(255, 255, 255, 0.08)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '12px',
    padding: '1.2rem',
    width: '220px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0,0,0,0.15)',
    backdropFilter: 'blur(8px)',
    color: '#0A1733',
  },
  iconBox: {
    fontSize: '2rem',
    color: '#e63946',
    flexShrink: 0,
  },
  formMapContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2rem',
    padding: '2rem',
    justifyContent: 'space-between',
  },
  formStyle: {
    flex: '1 1 48%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  rowStyle: {
    display: 'flex',
    gap: '1rem',
  },
  inputStyle: {
    flex: 1,
    padding: '0.75rem',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  buttonStyle: {
    // padding: '0.75rem',
    // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
    // backgroundImage: `url("https://www.transparenttextures.com/patterns/light-wool.png"), linear-gradient(to right, #0f2027, #203a43, #2c5364)`,

    color: '#0A1733',
    // border: 'none',
    // borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: "bold",
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '2rem',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(8px)',
  },
  mapStyle: {
    flex: '1 1 48%',
    border: 0,
    minHeight: '400px',
    borderRadius: '8px',
  },
  heading: {
    fontSize: '60px',
    fontWeight: 'bold',
    textAlign: "center",
    color: "#0A1733"
  },
  orangeText: {
    color: '#f37021',
  },
};

export default ContactUs;
